export const MEMBER_REFLECTION_PROFILE_SLUG = 'member-reflection';
export const CHEM_CALL_REFLECTION_MEMBER_PROFILE_SLUG =
  'chem-call-reflection-member';

// Moments' member-artifact endpoints accept this filter as a comma-delimited
// `profile_slug` value (parsed server-side by artifact.ParseProfileSlugs).
export const MEMBER_REFLECTION_PROFILE_SLUGS = [
  MEMBER_REFLECTION_PROFILE_SLUG,
  CHEM_CALL_REFLECTION_MEMBER_PROFILE_SLUG,
] as const;

export const isMemberReflectionProfile = (profileSlug: string) =>
  MEMBER_REFLECTION_PROFILE_SLUGS.some((slug) => slug === profileSlug);

export const memberReflectionLabel = (profileSlug: string) =>
  profileSlug === CHEM_CALL_REFLECTION_MEMBER_PROFILE_SLUG
    ? 'Chemistry Call Reflection'
    : 'Session Reflection';

export const memberReflectionDescription = (profileSlug: string) =>
  profileSlug === CHEM_CALL_REFLECTION_MEMBER_PROFILE_SLUG
    ? 'View your chemistry call reflection'
    : 'View your session reflection';
